import React from 'react'
import styled from 'styled-components'
import logoSrc from '../static/images/general/logo.png'
import arrowDown from '../static/images/icons/arrow_down.png'
import introBg from '../static/images/backgrounds/enter_pic_mobile.jpg'
import deskIntroBg from '../static/images/backgrounds/enter_pic.jpg'
import { colors, media } from '../styles/vars'
import { Link as ScrollLink } from 'react-scroll'

const Container = styled.div`
padding:100px 0 20vh;
background-image:url(${introBg});
background-repeat:no-repeat;
background-size:cover;
position:relative;
&:after{
    content:'';
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    height:20px;
    background-color:${colors.black};
}
${
    media.desktop`
    background-image:url(${deskIntroBg});
    padding:200px 0 35vh 0;
    background-position:center right;
    `
    }
`
const LogoContainer = styled.div`
max-width:90%;
margin:0 auto;
text-align:center;
${
    media.desktop`
    max-width:initial;
    `
    }
`
const ArrowDownContainer = styled.div`
position:absolute;
bottom:-35px;
left:0;
right:0;
margin:0 auto;
width:91px;
z-index:1;
cursor:pointer;
`

const IntroText = styled.p`
font-weight:600;
font-family:'Open Sans Hebrew';
margin:5px auto;
padding:10px;
color:${colors.red};
max-width:88%;
text-align:center;
font-size:2.1rem;
background-color:rgba(255, 255, 255, .7);
span{
    display:block;
    font-weight:400;
    color:${colors.black};
    font-size:85%;
    margin-top:5px;
}
${
    media.desktop`
    max-width:97.5%;
    font-size:2.4rem;
    label{
        display:block;
        margin:0 auto;
        max-width:90%;
    }
    `
    }
`
const Content = styled.div`
margin:0 auto;
max-width:500px;
${
    media.desktop`
    margin:0;
    transform:translate3d(-299px,-88px,0);
    `
    }
`
const IntroSection = () => {
    return (
        <Container>
            <Content>
                <LogoContainer>
                    <img src={logoSrc} alt="70 שנה על הכביש" />
                </LogoContainer>
                <IntroText>
                    המהפכה המוטורית של ישראל בשבעה עשורים: כך זה קרה
                </IntroText>
            </Content>
            <ArrowDownContainer>
                <ScrollLink
                    to="timeline"
                    smooth={true}
                    duration={500}
                >
                    <img src={arrowDown} alt="" />
                </ScrollLink>
            </ArrowDownContainer>
        </Container>
    )
}

export default IntroSection;


// WEBPACK FOOTER //
// ./src/containers/IntroSection.jsx